import {
  headerSearchBarFix,
  updateContentMargin,
  modifyFeatureLineup,
  updateSocialWidgetPosition,
} from './utils/helpers';
import { setNavItemAttributes, updateMenuButton } from './utils/handleNavigation';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website');
  updateMenuButton();
  modifyFeatureLineup();

  $(globalThis).on('load', function () {
    setNavItemAttributes();
    updateContentMargin();
    updateSocialWidgetPosition();
  });
});
